import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { ApiService } from 'src/app/core/services/api.service';
import { NotificationService } from 'src/app/core/services/notification.service';
@Component({
  selector: 'app-overspeeding-notification',
  templateUrl: './overspeeding-notification.component.html',
  styleUrls: ['./overspeeding-notification.component.scss']
})
export class OverspeedingNotificationComponent implements OnInit {

  remark: any;

  constructor(
    public dialogRef: MatDialogRef<OverspeedingNotificationComponent>,
    private readonly apiService: ApiService,
    private notifyService: NotificationService,
    private ngxLoader: NgxUiLoaderService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
  }

  submit(): void {
    const requestedData = {
      tripId: this.data.tripId,
      overSpeedingRemark: this.remark
    };

    this.ngxLoader.start();
    this.apiService.doPostRequestWithResponse(ApiConstants.submitRemark, requestedData,
      success => {
        this.ngxLoader.stop();
        const isSuccess = success.status === 200;
        const message = isSuccess ? "Successfully Submitted the Remark" : "Error in submitting the remark";
        this.notifyService.showSuccess(message, null);
        if (isSuccess) {
          this.dialogRef.close("success");
        }
      },
      error => {
        this.ngxLoader.stop();
        this.notifyService.showError(error, null);
      }
    );
  }


  onClickCancel(): void {
    this.dialogRef.close("close");
  }
}
